import { formattedDate } from "../../components/formatted/FormattedDateAndTime";
import { isNotificationAllowed } from "../notificationUtils";

export const filterAllowedNotifications = (notifications, user) =>
  notifications.filter((notification) =>
    isNotificationAllowed(notification, user),
  );

export const filterNotificationsByRead = (notifications, unreadOnly) => {
  if (!unreadOnly) {
    return notifications;
  }
  return notifications.filter((notification) => !notification.read);
};

export const sortNotificationsByDateDesc = (notifications) =>
  [...notifications].sort(
    (left, right) =>
      new Date(right.date).getTime() - new Date(left.date).getTime(),
  );

const getNotificationDayGroupLabel = (date, t) => {
  const notificationDay = new Date(date).toDateString();
  const today = new Date().toDateString();
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  if (notificationDay === today) {
    return t("Today");
  }
  if (notificationDay === yesterday.toDateString()) {
    return t("Yesterday");
  }
  return formattedDate(date, t, true);
};

export const groupNotificationsByDay = (notifications, t) => {
  const groups = [];

  notifications.forEach((notification) => {
    const label = getNotificationDayGroupLabel(notification.date, t);
    const existingGroup = groups.find((group) => group.label === label);

    if (existingGroup) {
      existingGroup.items.push(notification);
      return;
    }

    groups.push({ label, items: [notification] });
  });

  return groups;
};
